import React from 'react';
import _ from 'lodash';
import { toJS } from "mobx";
import { AxlInput, AxlPanel, AxlTextArea, AxlReselect } from 'axl-reactjs-ui';
import {Button, FormControlLabel, Checkbox} from "@material-ui/core";
// Utils
import ParcelComponent from './ParcelComponent.js';

// styles
import styles, * as E from '../../styles';
import CurrencyInput from "../../../../components/CurrencyInput";
import {currencyOptions} from "../../../../components/ShipmentValueInfoForm/validCurrencyCodes";

export default class SingleOrderStepOne extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemIds: [{itemId: ''}],
      searchKey: '',
    };
    this.addMoreItemID = this.addMoreItemID.bind(this);
  }

  addMoreItemID() {
    const initItemID = [{itemID: ''}];
    const itemIDMerged = _.concat(this.state.itemIds, initItemID);
    this.setState({itemIds: itemIDMerged});
  }

  render() {
    const {searchShipment, getFormError, getFormValue, handleInputForm, searchingShipment, shipmentTags, shipment, setFormValue, userStore} = this.props;
    const { isBrandsOwner, clientProfileOptions } = userStore;
    const brandOptions = [{label: 'Default', value: null}].concat(toJS(clientProfileOptions));
    const tags = shipment.tags || [];
    const currentCurrency = getFormValue('currency', '' );
    const currentCurrencyIndex = currencyOptions.find(c=>c.value === currentCurrency);
    const currentBrandValue = getFormValue('client_profile_id', '');
    const currentBrand = brandOptions.find(cp => cp.value === currentBrandValue);

    return (
      <E.StepContainer>
        <E.Row style={styles.row_1}>
          <E.InputShipment>
            <AxlInput
                placeholder={`Enter internal ID, past tracking code to auto-fill order information`}
                onChange={(e) => this.setState({searchKey: e.target.value})}
                onEnter={() => searchShipment(this.state.searchKey)}
                name={`search`} fluid style={{width: '100%', height: 46}}
                value={this.state.searchKey}
            />
          </E.InputShipment>
          <Button
            variant="contained"
            color="primary"
            loading={searchingShipment}
            onClick={() => searchShipment(this.state.searchKey)}
            style={{marginLeft: 10}}>{`Enter`}</Button>
        </E.Row>
        <E.Panel>
          <E.PanelTitle>{`Customer Information`}</E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label isError={!!getFormError("customer.name")}>{`Full name`}<E.Text_4 isError={!!getFormError("customer.name")}>{` - required`}</E.Text_4></E.Label>
                  <AxlInput placeholder={`First/ Last name`}
                            onChange={handleInputForm}
                            name="customer.name"
                            error={getFormError("customer.name")}
                            value={getFormValue("customer.name")}
                            fluid style={styles.input}
                            showError={false}
                  />
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Email address`}</E.Label>
                  <AxlInput placeholder={`email@company.com`}
                            onChange={handleInputForm}
                            name="customer.email"
                            error={getFormError("customer.email")}
                            value={getFormValue("customer.email")}
                            fluid style={styles.input}
                            showError={false}
                  />
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Phone no.`}</E.Label>
                  <AxlInput placeholder={``}
                            onChange={handleInputForm}
                            name="customer.phone_number"
                            error={getFormError("customer.phone_number")}
                            value={getFormValue("customer.phone_number")}
                            fluid style={styles.input}
                            showError={false}
                  />
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
        <E.Panel>
          <E.PanelTitle>{`Order Information`}</E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              {isBrandsOwner && (
                <AxlPanel.Row style={styles.row}>
                  <AxlPanel.Col style={styles.col}>
                    <E.Label>{`Brand name`}</E.Label>
                    <AxlReselect
                      fluid showError={false}
                      name="client_profile_id"
                      theme={`main`}
                      placeholder={'Default'}
                      onChange={e => setFormValue("client_profile_id", e.value)}
                      options={brandOptions}
                      value={currentBrand}
                    />
                  </AxlPanel.Col>
                </AxlPanel.Row>
              )}
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Internal ID`}</E.Label>
                  <AxlInput
                    placeholder={`e.g: 12345678`}
                    onChange={handleInputForm}
                    name="internal_id"
                    error={getFormError("internal_id")}
                    value={getFormValue("internal_id")}
                    fluid style={styles.input}
                  />
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Order description`}<E.I>{` - optional`}</E.I></E.Label>
                  <AxlTextArea
                    placeholder={`Tell us more about order items/ details…`}
                    onChange={handleInputForm}
                    name="order_detail"
                    error={getFormError("order_detail")}
                    value={getFormValue("order_detail")}
                    fluid style={styles.textarea}
                  />
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Value`}<E.I>{` - optional`}</E.I></E.Label>
                  <CurrencyInput style={{...styles.moneyInput}}
                                 type="text"
                                 onChange={handleInputForm}
                                 name='value'
                                 required
                                 value={getFormValue("value")}
                  />
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Currency`}<E.I>{` - optional`}</E.I></E.Label>
                  <AxlReselect
                      fluid showError={false}
                      name='currency'
                      theme={`main`}
                      placeholder={'Select currency'}
                      onChange={(selected)=>{
                        setFormValue('currency',selected.value);
                      }}
                      options={currencyOptions}
                      value={currentCurrencyIndex}
                  />
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Tags`}<E.I>{` - optional`}</E.I></E.Label>
                  <E.CheckboxGroup>
                  {shipmentTags && shipmentTags.map((tag, index) =>
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          checked={tags.indexOf(tag) > -1} 
                          name={`tags`} 
                          value={tag}
                          color="primary" 
                          onChange={handleInputForm}
                        />
                        } 
                      label={tag.toUpperCase()} 
                    />
                  )}
                  </E.CheckboxGroup>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <ParcelComponent {...this.props} />
              {/*<AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Item ID`}</E.Label>
                  {this.state.itemIds.map(item => <AxlInput placeholder={`e.g: 12345678`} onChange={() => console.log('onchange')} fluid style={styles.input_2} defaultValue={item.itemId}/>)}
                  <E.AddMore onClick={this.addMoreItemID}><i className="fa fa-plus-circle" style={styles.add} />{`Add another item ID`}</E.AddMore>
                </AxlPanel.Col>
              </AxlPanel.Row>*/}
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
      </E.StepContainer>
    );
  }
}
